// Lietuvių. Please have a native speaker review before launch.
export default {
    // Research papers page (/research)
    "nav.globe": "Gaublys",
    "nav.research": "Tyrimai",
    "rs.title": "Moksliniai tyrimai",
    "rs.sub": "Nauji kiekybinių finansų ir centrinių bankų tyrimai iš arXiv, Fed, ECB, BIS ir NBER. Nemokamai skaitomi šaltinyje; atnaujinama kas 6 valandas.",
    "rs.search": "Ieškokite pavadinimų, autorių, santraukų…",
    "rs.allTopics": "Visos temos",
    "rs.allSources": "Visi šaltiniai",
    "rs.allCountries": "Visos šalys",
    "rs.count": "Tyrimų: {n}",
    "rs.none": "Pagal šiuos filtrus tyrimų nėra.",
    "rs.clear": "Išvalyti filtrus",
    "rs.download": "Atsisiųsti PDF iš {source}",
    "rs.read": "Skaityti {source}",
    "rs.onGlobe": "Atidaryti {country} gaublyje",
    "rs.note": "Pavadinimai, autoriai ir santraukos veda į originalius leidėjus; PDF atsidaro jų svetainėse. Tyrimai, ne finansinė konsultacija.",
    "rs.global": "Pasaulis",
    "rs.loadMore": "Rodyti daugiau",
    "rs.details": "Išsamiau",
    "rs.copy": "Kopijuoti nuorodą",
    "rs.copied": "Nuoroda nukopijuota",
    "rs.published": "Paskelbta",
    "panel.research": "Tyrimai apie šalį: {country}",
    "panel.researchAll": "Visi tyrimai →",
    "rt.trading": "Prekyba ir rinkos struktūra",
    "rt.portfolio": "Portfeliai ir investavimas",
    "rt.risk": "Rizika",
    "rt.pricing": "Išvestinės priemonės ir kainodaros modeliai",
    "rt.forecasting": "DI ir prognozės",
    "rt.crypto": "Kriptovaliutos ir skaitmeninis turtas",
    "rt.macro": "Ekonomika ir centriniai bankai",
    "topic.r-trading": "Prekybos tyrimai nagrinėja, kaip formuojasi kainos ir vykdomi pavedimai: strategijas, pavedimų knygas, likvidumą ir sąnaudas.",
    "topic.r-portfolio": "Portfelių tyrimai klausia, kaip derinti investicijas: kokie veiksniai paaiškina grąžą, kaip suderinti riziką ir grąžą ir kaip investuoti pensijai.",
    "topic.r-risk": "Rizikos tyrimai matuoja, kas gali nepavykti: didelius nuostolius, rinkos griūtis, bankų bankrotus ir kaip nuo jų apsisaugoti.",
    "topic.r-pricing": "Kainodaros tyrimai kuria matematiką, kuria vertinami opcionai ir kiti sandoriai, bei kintamumo modelius.",
    "topic.r-forecasting": "DI ir prognozių tyrimai tikrina, ar mašininis mokymasis, kalbos modeliai ir statistika gali numatyti kainas ar ekonomiką ir kaip patikimai.",
    "topic.r-crypto": "Kriptovaliutų tyrimai nagrinėja kriptovaliutas, stabiliąsias monetas, blokų grandines ir tokenizuotą turtą: kaip jais prekiaujama ir kokia jų rizika.",
    "topic.r-macro": "Ekonomikos tyrimai nagrinėja augimą, infliaciją, palūkanų normas ir centrinių bankų politiką, kurie lemia rinkas mėnesius ir metus.",
    'lang.label': 'Kalba',
    'nav.reports': 'Ataskaitos',
    'nav.stocks': 'Akcijų stebėjimas',
    loading: 'Įkeliamos pasaulio naujienos…',
    'err.title': 'Nepavyko įkelti',
    'err.msg': 'Įkeliant programą įvyko klaida.',
    'err.retry': 'Bandyti dar kartą',
    atlas: 'Atlasas',
    'search.label': 'Ieškoti šalių',
    'search.ph': 'Ieškoti šalių arba kodų…',
    'filter.region': 'Regionas',
    'filter.allRegions': 'Visi regionai',
    'filter.window': 'Laikotarpis',
    'filter.topic': 'Tema',
    'filter.all': 'Visos',
    'stage.title': 'Rinkos dabar',
    legend: 'Legenda',
    lastUpdate: 'Atnaujinta',
    pauseRotation: 'Sustabdyti sukimą',
    resumeRotation: 'Tęsti sukimą',
    hint: 'Vilkite, kad pasuktumėte · spustelėkite tašką, kad atidarytumėte šalį',
    'panel.latest': 'Naujausios',
    'quiet.none': 'Šiuo laikotarpiu naujienų nėra.',
    'quiet.sub': 'Pasirinkite ilgesnį laikotarpį (7D arba 30D) arba sekite šią šalį, kad ji liktų jūsų sąraše.',
    'footer.about': 'Apie',
    'footer.privacy': 'Privatumas',
    'footer.terms': 'Sąlygos',
    follow: '☆ Sekti',
    following: '★ Sekama',
    followingGroup: 'Sekamos',
    explain: 'Paaiškink',
    hideExplain: 'Slėpti paaiškinimą',
    share: 'Dalintis',
    whyMatter: 'Kodėl tai gali būti svarbu',
    disclaimer: 'Švietimo tikslais, ne finansinė konsultacija.',
    readAt: 'Skaityti visą naujieną: {source}',
    translate: 'Versti',
    showing: 'Rodoma {n} iš {total}',
    loadMore: 'Įkelti dar {n}',
    loadingShort: 'Įkeliama…',
    'story.one': '{n} naujiena',
    'story.few': '{n} naujienos',
    'story.many': '{n} naujienos',
    'story.other': '{n} naujienų',
    noStories: 'naujienų nėra',
    justNow: 'Ką tik',
    minAgo: 'prieš {n} min.',
    hAgo: 'prieš {n} val.',
    dAgo: 'prieš {n} d.',
    'range.24h': 'pastarosios 24 valandos',
    'range.7d': 'pastarosios 7 dienos',
    'range.30d': 'pastarosios 30 dienų',
    'range.all': 'visas laikotarpis',
    'cont.Africa': 'Afrika',
    'cont.Asia': 'Azija',
    'cont.Europe': 'Europa',
    'cont.North America': 'Šiaurės Amerika',
    'cont.Oceania': 'Okeanija',
    'cont.South America': 'Pietų Amerika',
    'cat.markets': 'Rinkos',
    'cat.economy': 'Ekonomika',
    'cat.central-banks': 'Centriniai bankai',
    'cat.policy': 'Politika ir geopolitika',
    'cat.companies': 'Įmonės',
    today: 'Šiandien',
    'today.top': 'Pasaulis per 60 sekundžių',
    'today.banks': 'Centrinių bankų sprendimai',
    'today.mine': 'Jūsų šalys',
    'today.emptyTop': 'Šiandien svarbių naujienų dar nėra. Užsukite vėliau.',
    'today.emptyMine': 'Paspauskite ☆ Sekti prie bet kurios šalies, kad ją čia prisegtumėte.',
    'today.note': 'Antraštės nukreipia į pirminius šaltinius. Tik švietimo tikslais, ne finansinė konsultacija.',
    'today.open': 'Atidaryti: {country}',
    close: 'Uždaryti',
    'cal.timeVaries': 'laikas kinta',
    'cal.yourTime': '{time} jūsų laiku',
    'cal.in': 'po {t}',
    'cal.today': 'Sprendimas skelbiamas šiandien',
    'bank.fed': 'JAV federalinis rezervų bankas',
    'bank.ecb': 'Europos centrinis bankas',
    'bank.boe': 'Anglijos bankas',
    'bank.boj': 'Japonijos bankas',
    'auth.signIn': 'Prisijungti',
    'auth.account': 'Paskyra',
    'auth.btnTitle': 'Nemokama paskyra: išsaugokite savo šalis visuose įrenginiuose',
    'auth.freeTitle': 'Nemokama paskyra',
    'auth.freeSub': "Išsaugokite sekamas šalis visuose įrenginiuose. Be slaptažodžio: atsiųsime vienkartinį kodą el. paštu.",
    'auth.emailBtn': "Atsiųsti prisijungimo kodą",
    'auth.sending': 'Siunčiama…',
    'auth.check': 'Patikrinkite el. paštą: nuoroda galioja 20 minučių.',
    "auth.codeTitle": "Patikrinkite el. paštą",
    "auth.codeSent": "Išsiuntėme 6 skaitmenų kodą adresu {email}. Įveskite jį čia:",
    "auth.codeLabel": "Prisijungimo kodas",
    "auth.codeBtn": "Prisijungti",
    "auth.junk": "Nematote? Gali užtrukti minutę. Patikrinkite ir šlamšto (Spam) aplanką ir pažymėkite laišką „Ne šlamštas“, kad kiti laiškai pasiektų gautuosius.",
    "auth.otherEmail": "Naudoti kitą el. paštą",
    'auth.dev': 'Kūrimo režimas (el. pašto serveris nenustatytas):',
    'auth.devLink': 'spustelėkite čia, kad prisijungtumėte',
    'auth.fine': 'Jūsų el. paštą naudojame tik prisijungimui. Žr. {link}.',
    'auth.privacy': 'privatumo pranešimą',
    'auth.yourAccount': 'Jūsų paskyra',
    'auth.signedInAs': 'Prisijungta kaip {email}',
    'auth.followCount': 'Sekamų šalių: {n}. Sinchronizuota visuose įrenginiuose.',
    'auth.signOut': 'Atsijungti',
    'auth.delete': 'Ištrinti paskyrą',
    "auth.confirmDelete": "Ištrinti paskyrą? Bus ištrintas jūsų el. paštas ir išsaugotos šalys, o NewsNetWide laiškų nebegausite. To atšaukti negalima.",
    'auth.deletedTitle': 'Paskyra ištrinta',
    "auth.deletedSub": "Jūsų el. paštas, išsaugotos šalys ir el. laiškų prenumerata ištrinti.",
    'auth.inTitle': 'Jūs prisijungėte',
    'auth.inSub': 'Sveiki, {email}. Sekamos šalys dabar išsaugotos jūsų paskyroje.',
    'auth.expired': 'Ši nuoroda nebegalioja. Paprašykite naujos žemiau.',
    'auth.used': 'Ši nuoroda jau panaudota arba negalioja. Paprašykite naujos žemiau.',
    'share.source': 'Šaltinis',
    'share.tagline': 'Visos rinkas judinančios naujienos viename gaublyje',
    'share.notAdvice': 'Naujienos, ne finansinė konsultacija',
    'mc.open': 'Atvira',
    'mc.pre': 'Prieš prekybą',
    'mc.post': 'Po prekybos',
    'mc.night': 'Naktinė sesija',
    'mc.break': 'Pietų pertrauka',
    'mc.closed': 'Uždaryta',
    'mc.holiday': 'Šventė',
    'mc.closesIn': 'Užsidaro po {t}',
    'mc.opensIn': 'Atsidaro po {t}',
    'mc.endsIn': 'Baigiasi po {t}',
    'mc.reopensIn': 'Vėl atsidaro po {t}',
    'mc.preIn': 'Prekyba prieš atidarymą po {t}',
    'mc.afterIn': 'Prekyba po uždarymo po {t}',
    'mc.nightIn': 'Naktinė sesija po {t}',
    'mc.openCount': 'Atvirų: {n}',
    'mc.all': 'Visos rinkos',
    "mc.title": "Rinkų darbo laikas",
    "side.countries": "Šalys",
    "side.menu": "Meniu",
    "tools.pricingSub": "Planai ir ką kiekvienas apima",
    'mc.noHolidays': 'šventės neįtrauktos',
    'mc.local': 'vietos laiku',
    'mc.note': 'Įprastos kiekvienos biržos prekybos valandos vietos laiku. Šventės įtrauktos JAV, JK, Vokietijos ir Euronext Paris rinkoms (2026–27); kitos biržos gali nedirbti per vietines šventes. Naktinės sesijos yra indeksų ateities sandorių sesijos (Tokijo OSE, Honkongo HKFE).',
    'topic.markets': 'Rinkų naujienos apie akcijų, obligacijų, valiutų ir žaliavų kainas: ką investuotojai perka ir parduoda, ir kodėl.',
    'topic.economy': 'Ekonomikos naujienos (augimas, užimtumas, infliacija, prekyba) lemia įmonių pelną ir centrinių bankų sprendimus artimiausiais mėnesiais.',
    'topic.central-banks': 'Centriniai bankai nustato palūkanų normas, t. y. pinigų kainą, nuo kurios priklauso paskolos, santaupos, valiutos ir turto kainos.',
    'topic.policy': 'Vyriausybių sprendimai (mokesčiai, biudžetai, prekybos taisyklės, sankcijos, rinkimai, konfliktai) gali keisti ištisų sektorių kaštus ir rizikas.',
    'topic.companies': 'Įmonių naujienos (rezultatai, sandoriai, atleidimai) gali judinti jų akcijas, o kartais ir visą sektorių.',
    "snap.title": "Investuotojo apžvalga",
    "snap.source": "Naujausi oficialūs metiniai duomenys · World Bank Open Data. Kontekstas, ne prognozė ar patarimas.",
    "snap.gdp_growth": "BVP augimas",
    "snap.inflation": "Infliacija",
    "snap.unemployment": "Nedarbas",
    "snap.gdp_per_capita": "BVP vienam gyventojui",
    "snap.current_account": "Einamoji sąskaita",
    "snap.exports": "Eksportas",
    "snap.ofGdp": "BVP",
    "snap.gdp.shrink": "Ekonomika traukiasi.",
    "snap.gdp.slow": "Lėtas augimas.",
    "snap.gdp.moderate": "Vidutinis augimas.",
    "snap.gdp.fast": "Spartus augimas.",
    "snap.inf.deflation": "Kainos krenta (defliacija).",
    "snap.inf.target": "Arti ~2 % tikslo, kurio siekia dauguma centrinių bankų.",
    "snap.inf.above": "Virš įprastų centrinių bankų tikslų.",
    "snap.inf.high": "Didelė infliacija: pinigai greitai nuvertėja.",
    "snap.unemp.low": "Žemas: darbo rinka įtempta.",
    "snap.unemp.moderate": "Vidutinis.",
    "snap.unemp.high": "Aukštas: daug žmonių neranda darbo.",
    "snap.gdppc.note": "Vidutinė gamyba vienam žmogui: apytikslis šalies turtingumo matas.",
    "snap.ca.surplus": "Perteklius: iš užsienio uždirba daugiau, nei išleidžia.",
    "snap.ca.deficit": "Deficitas: užsienyje išleidžia daugiau, nei uždirba, ir priklauso nuo užsienio pinigų.",
    "snap.exp.very": "Labai priklauso nuo prekybos: jautri muitams ir pasaulinei paklausai.",
    "snap.exp.open": "Atvira prekybos ekonomika.",
    "snap.exp.domestic": "Daugiausia remiasi vidaus rinka.",
    "auth.since": "Narys nuo {date}",
    "auth.followed": "Šalys, kurias sekate",
    "auth.noneFollowed": "Kol kas nėra. Paspauskite ☆ Sekti prie bet kurios šalies, kad ją čia pridėtumėte.",
    "auth.unfollow": "Nebesekti {country}",
    "auth.email": "El. paštas",
    "auth.prefUpdates": "NewsNetWide naujienos",
    "auth.prefUpdatesSub": "Naujos funkcijos ir svetainės naujienos",
    "auth.prefNews": "Naujienlaiškis",
    "auth.prefNewsSub": "Svarbiausios rinkų naujienos",
    "auth.saved": "Išsaugota.",
    "auth.prefsError": "El. pašto nustatymai šiuo metu nepasiekiami.",
    "auth.plan": "Planas",
    "auth.seePlans": "Peržiūrėti planus",
    "auth.manage": "Tvarkyti prenumeratą",
    "auth.trialUntil": "nemokamas bandymas iki {date}",
    "auth.renews": "atsinaujina {date}",
    "auth.endsOn": "baigiasi {date}",
    "auth.briefing": "Rytinė apžvalga",
    "auth.briefingOn": "Siųskite man rytinę apžvalgą",
    "auth.briefingSub": "Svarbiausios naujienos iš šalių, kurias sekate, ir artėjančios svarbios datos. Galite atsisakyti bet kada.",
    "auth.briefingNone": "Dar nesekate jokios šalies, todėl apžvalga prasidės nuo svarbiausių pasaulio naujienų.",
    "auth.briefingCount": "Šalys jūsų apžvalgoje: {n}",
    "auth.briefingAt": "Siųsti",
    "auth.briefingTz": "jūsų laiku ({tz})",
    "auth.briefingPreview": "Šiandienos pavyzdys ↗",
    "panel.page": "Šalies puslapis ↗",
    "footer.countries": "Šalys",
    glossary: {
        'central-bank': ['Centrinis bankas', 'Institucija, nustatanti šalies palūkanų normas ir valdanti pinigų kiekį.', 'Jos sprendimai keičia skolinimosi kainą visiems ir judina obligacijas, akcijas bei valiutą.'],
        fed: ['Federalinis rezervų bankas (Fed)', 'JAV centrinis bankas; jo komitetas (FOMC) nustato JAV palūkanas.', 'JAV palūkanos veikia skolinimosi kainą ir investicijų srautus visame pasaulyje.'],
        ecb: ['Europos centrinis bankas (ECB)', 'Centrinis bankas 20 šalių, naudojančių eurą.', 'Jo sprendimai veikia būsto paskolas, verslo kreditus ir euro vertę.'],
        boe: ['Anglijos bankas', 'JK centrinis bankas; jo Pinigų politikos komitetas nustato JK palūkanas.', 'Jo sprendimai judina svarą, JK vyriausybės obligacijas ir skolinimosi kainą.'],
        boj: ['Japonijos bankas', 'Japonijos centrinis bankas.', 'Labai žemų Japonijos palūkanų pokyčiai gali judinti jeną ir pasaulinius kapitalo srautus.'],
        'interest-rate': ['Palūkanų norma', 'Skolintų pinigų kaina, paprastai metinis procentas.', 'Didesnės palūkanos brangina paskolas ir mažina išlaidas; mažesnės veikia priešingai.'],
        'rate-cut': ['Palūkanų mažinimas', 'Centrinis bankas sumažina palūkanų normą.', 'Pigesnis skolinimasis gali paremti išlaidas ir pelną, bet gali rodyti ir nerimą dėl ekonomikos.'],
        'rate-hike': ['Palūkanų didinimas', 'Centrinis bankas padidina palūkanų normą.', 'Dažniausiai siekiama sulėtinti infliaciją; paskolos šeimoms ir įmonėms brangsta.'],
        'basis-points': ['Baziniai punktai', 'Vienas bazinis punktas yra 0,01 %; 25 baziniai punktai yra ketvirtis procentinio punkto.', 'Palūkanų pokyčiai nurodomi baziniais punktais, todėl matyti pokyčio dydis.'],
        qe: ['Kiekybinis skatinimas (QE)', 'Centrinis bankas perka (QE) arba mažina (QT) didelius obligacijų kiekius, kad paveiktų ilgalaikes palūkanas.', 'Tai keičia, kiek pinigų cirkuliuoja finansų rinkose.'],
        inflation: ['Infliacija', 'Kainų augimo tempas; dažniausiai matuojamas vartotojų kainų indeksu (VKI).', 'Didelė infliacija gali palaikyti aukštas palūkanas ir mažina perkamąją galią.'],
        gdp: ['BVP', 'Bendrasis vidaus produktas: visų ekonomikos sukurtų prekių ir paslaugų vertė.', 'Tai plačiausias rodiklis, ar ekonomika auga, ar traukiasi.'],
        recession: ['Recesija', 'Reikšmingas ir platus ekonominės veiklos sumažėjimas, dažnai du ketvirčiai mažėjančio BVP.', 'Recesijos paprastai reiškia mažesnį įmonių pelną ir didesnį nedarbą.'],
        unemployment: ['Nedarbas', 'Dalis žmonių, kurie nori dirbti, bet neturi darbo; užimtumo duomenys skaičiuoja naujas darbo vietas.', 'Darbo rinkos duomenys rodo ekonomikos stiprumą ir veikia centrinius bankus.'],
        pmi: ['PMI', 'Pirkimų vadybininkų indeksas: mėnesinė verslo veiklos apklausa. Daugiau nei 50 reiškia augimą.', 'Tai vienas ankstyviausių signalų, kur juda ekonomika.'],
        'trade-deficit': ['Prekybos balansas', 'Skirtumas tarp šalies eksporto ir importo.', 'Dideli disbalansai gali paveikti valiutą ir sukelti prekybos ginčus.'],
        tariff: ['Muitas', 'Mokestis importuojamoms prekėms.', 'Muitai brangina importą ir gali mažinti eksportuotojų pardavimus bei pelną.'],
        sanctions: ['Sankcijos', 'Apribojimai, kuriuos viena šalis taiko prekybai ar finansams su kita.', 'Jos gali uždaryti rinkas, sutrikdyti tiekimo grandines ir judinti žaliavų kainas.'],
        budget: ['Biudžetas ir fiskalinė politika', 'Kaip valstybė renka mokesčius, išleidžia ir skolinasi.', 'Dideli deficitai ar skatinimas gali paveikti augimą, obligacijų pajamingumą ir valiutą.'],
        'bond-yield': ['Obligacijų pajamingumas', 'Investuotojo grąža iš obligacijos; kai obligacijos kaina krenta, pajamingumas auga.', 'Vyriausybės obligacijų pajamingumas nustato bazinę skolinimosi kainą visoje ekonomikoje.'],
        index: ['Akcijų indeksas', 'Akcijų krepšelis, atspindintis rinką, pvz., S&P 500 (500 didelių JAV įmonių).', 'Indeksai vienu skaičiumi apibendrina visos rinkos būklę.'],
        'sell-off': ['Masinis pardavimas', 'Laikotarpis, kai daug investuotojų parduoda vienu metu ir kainos sparčiai krenta.', 'Dažnai atspindi baimę ar blogas naujienas; nieko tikro nepasako apie ateitį.'],
        volatility: ['Kintamumas', 'Kaip stipriai ir greitai kyla bei krenta kainos.', 'Didesnis kintamumas reiškia daugiau neapibrėžtumo ir didesnius svyravimus abiem kryptimis.'],
        currency: ['Valiutos kursas', 'Vienos valiutos kaina, išreikšta kita valiuta.', 'Kursų pokyčiai keičia importo, kelionių kainą ir užsienio investicijų vertę.'],
        oil: ['Naftos kainos', 'Žalios naftos rinkos kaina; pagrindiniai etalonai yra Brent ir WTI. OPEC vienija naftą išgaunančias šalis.', 'Nafta veikia kuro, transporto ir gamybos kaštus, taigi ir infliaciją.'],
        gold: ['Auksas', 'Auksas kaip prekybos žaliava.', 'Daug investuotojų jį perka neramiais laikais, todėl jo kaina dažnai atspindi nerimą.'],
        crypto: ['Kriptovaliuta', 'Skaitmeninis turtas, pvz., bitkoinas, kuriuo prekiaujama visą parą be centrinio banko.', 'Kainos labai kintančios ir reaguoja į reguliavimą bei rizikos apetitą.'],
        etf: ['ETF', 'Biržoje prekiaujamas fondas, dažniausiai sekantis indeksą.', 'ETF yra paplitęs ir pigus būdas investuoti į visą rinką.'],
        earnings: ['Pelnas', 'Įmonės paskelbtas laikotarpio pelnas, dažnai vienai akcijai (EPS).', 'Rezultatai, geresni ar blogesni nei analitikų lūkesčiai, dažnai judina akcijų kainą.'],
        revenue: ['Pajamos', 'Visi pinigai, kuriuos įmonė gauna parduodama produktus ar paslaugas, prieš išlaidas.', 'Pajamų augimas rodo, ar didėja jos produktų paklausa.'],
        guidance: ['Įmonės prognozė', 'Pačios įmonės ateities rezultatų prognozė.', 'Prognozės pokyčiai investuotojams dažnai svarbūs tiek pat, kiek praeities rezultatai.'],
        ipo: ['Pirminis viešas siūlymas (IPO)', 'Kai įmonė pirmą kartą parduoda akcijas biržoje.', 'Visuomenė gali į ją investuoti; tai rodo susidomėjimą naujais listingais.'],
        merger: ['Susijungimai ir įsigijimai', 'Viena įmonė susijungia su kita arba ją nuperka.', 'Sandoriai gali pakeisti konkurenciją ir dažnai judina abiejų įmonių akcijas.'],
        buyback: ['Akcijų supirkimas', 'Įmonė superka savo akcijas iš rinkos.', 'Tai grąžina pinigus akcininkams ir mažina akcijų skaičių; vertės negarantuoja.'],
        dividend: ['Dividendai', 'Akcininkams išmokama pelno dalis.', 'Dividendų pokyčiai rodo, kiek įmonė pasitiki savo pinigų srautais.'],
        layoffs: ['Atleidimai', 'Įmonė mažina darbuotojų skaičių.', 'Tai gali rodyti kaštų spaudimą ar restruktūrizavimą ir veikia darbo rinką.'],
        bankruptcy: ['Bankrotas', 'Teisinis procesas, kai įmonė negali sumokėti skolų.', 'Akcininkai paprastai praranda beveik viską; kreditoriai gali atgauti dalį.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Kalendorius",
    "nav.tools": "Įrankiai",
    "nav.pricing": "Kainos",
    "tools.soon": "NETRUKUS",
    "tools.briefing": "Rytinė apžvalga",
    "tools.briefingSub": "Jūsų šalių naujienos el. paštu kiekvieną rytą",
    "tools.calculators": "Finansų skaičiuoklės",
    "tools.calculatorsSub": "Sudėtinės palūkanos, taupymo tikslai, mokesčiai",
    "tools.holdings": "Turimų akcijų stebėjimas",
    "tools.holdingsSub": "Naujienos apie jūsų turimas įmones",
    "tools.papers": "Straipsnių analizė",
    "tools.papersSub": "Bet kuris mokslinis straipsnis, paaiškintas paprastai",
    "tools.montecarlo": "Monte Karlo simuliatorius",
    "tools.montecarloSub": "Taupymas, prekyba ir opcionų strategijos su PDF",
    "cal.title": "Ekonomikos kalendorius",
    "cal.sub": "Centrinių bankų sprendimai, svarbiausi ekonomikos duomenys, biržų nedarbo dienos ir šventės – iš oficialių šaltinių, jūsų laiko juostoje.",
    "cal.todayLabel": "Šiandien",
    "cal.tomorrow": "Rytoj",
    "cal.yesterday": "Vakar",
    "cal.allDay": "Visą dieną",
    "cal.now": "dabar",
    "cal.inDH": "po {d} d. {h} val.",
    "cal.inHM": "po {h} val. {m} min.",
    "cal.inM": "po {m} min.",
    "cal.decision": "{bank}: sprendimas dėl palūkanų",
    "cal.closed": "{exchange} nedirba",
    "cal.early": "{exchange} užsidaro anksčiau",
    "cal.estimated": "numatoma data",
    "cal.yourTz": "Laikas jūsų laiko juostoje ({tz})",
    "cal.type.public_holiday": "Šventės",
    "cal.allCountries": "Visos šalys",
    "cal.yourCountries": "Jūsų šalys",
    "cal.noFollows": "Sekite šalis gaublyje, kad galėtumėte jas čia filtruoti.",
    "cal.addToCal": "Pridėti į kalendorių",
    "cal.subscribe": "Prenumeruoti",
    "cal.subscribeHint": "Nukopijuokite šią nuorodą į „Google“ kalendorių, „Apple“ kalendorių ar „Outlook“ („pridėti iš URL“). Jis atsinaujina pats.",
    "cal.copied": "Nuoroda nukopijuota",
    "cal.source": "Oficialus šaltinis",
    "cal.relatedNews": "Naujienos: {country}",
    "cal.period": "Laikotarpis: {period}",
    "cal.none": "Pagal šiuos filtrus nieko nesuplanuota.",
    "cal.error": "Kalendorius šiuo metu nepasiekiamas. Bandykite po akimirkos.",
    "cal.comingUp": "Netrukus",
    "cal.fullCalendar": "Visas kalendorius",
    "cal.euroArea": "Euro zona",
    "cal.note": "Datos ir laikas – iš centrinių bankų, biržų ir statistikos tarnybų (nuoroda prie kiekvieno įvykio). Šventės: atvirojo kodo biblioteka „holidays“ (MIT). Niekada nerodome prognozių. Naujienos ir kontekstas, ne finansinė konsultacija.",
    "cal.series.us_cpi": "JAV vartotojų kainos (VKI)",
    "cal.series.us_jobs": "JAV užimtumo ataskaita",
    "cal.series.us_ppi": "JAV gamintojų kainos (PPI)",
    "cal.series.us_jolts": "JAV laisvos darbo vietos (JOLTS)",
    "cal.series.us_eci": "JAV darbo sąnaudų indeksas",
    "cal.series.us_gdp": "JAV BVP",
    "cal.series.us_pce": "JAV gyventojų pajamos ir išlaidos (PCE)",
    "cal.series.us_trade": "JAV prekybos balansas",
    "cal.series.ea_hicp_flash": "Euro zonos infliacija (išankstinė)",
    "cal.series.ea_hicp": "Euro zonos infliacija (galutinė)",
    "cal.series.ea_gdp_flash": "Euro zonos BVP (išankstinis įvertis)",
    "cal.series.ea_gdp": "Euro zonos BVP ir užimtumas",
    "cal.series.ea_unemployment": "Euro zonos nedarbas",
    "cal.series.ea_retail": "Euro zonos mažmeninė prekyba",
    "cal.series.uk_cpi": "JK vartotojų kainos (VKI)",
    "cal.series.uk_gdp_q": "JK BVP (ketvirtinis)",
    "cal.series.uk_gdp_m": "JK BVP (mėnesinis)",
    "cal.series.uk_jobs": "JK darbo rinka",
    "cal.series.uk_retail": "JK mažmeninė prekyba",
    "cal.series.au_cpi": "Australijos vartotojų kainos (VKI)",
    "cal.series.au_jobs": "Australijos darbo jėga",
    "cal.series.au_gdp": "Australijos BVP",
    "bank.snb": "Šveicarijos nacionalinis bankas",
    "bank.boc": "Kanados bankas",
    "bank.rba": "Australijos rezervų bankas",
    "bank.rbnz": "Naujosios Zelandijos rezervų bankas",
    "bank.riksbank": "Švedijos centrinis bankas",
    "bank.norges": "Norvegijos bankas",
    "bank.rbi": "Indijos rezervų bankas",
    "cal.promise1": "Tik oficialūs šaltiniai",
    "cal.promise2": "Jokių prognozių – tik datos ir rezultatai",
    "cal.promise3": "Nemokama kalendoriaus prenumerata",
    "cal.yourTimeShort": "jūsų laikas",
    "cal.unitD": "d.",
    "cal.unitH": "val.",
    "cal.unitM": "min.",
    "cal.approxNote": "Apytikslis laikas: bankas jo iš anksto nenustato",
    "cal.then": "Toliau:",
    "cal.nextDecisions": "Artimiausi sprendimai dėl palūkanų",
    "cal.bankCalendars": "Oficialūs bankų kalendoriai · laikas iki paskelbimo",
    "cal.marketsWeek": "Biržos šią savaitę",
    "cal.mktAside": "Nedarbo dienų šią savaitę: {n} · laikas pagal {tz}",
    "cal.mktNote": "Tik pagrindinė prekybos sesija. Nedarbo dienos – iš kiekvienos biržos oficialaus švenčių sąrašo.",
    "cal.exchange": "Birža",
    "cal.rightNow": "Dabar",
    "cal.mkt.open": "Atidaryta",
    "cal.mkt.pre": "Dar neatidaryta",
    "cal.mkt.break": "Pietų pertrauka",
    "cal.mkt.closedToday": "Šiandien nedirba",
    "cal.mkt.closed": "Uždaryta",
    "cal.mkt.closesAt": "užsidaro {time} (jūsų laiku)",
    "cal.mkt.opensAt": "atsidaro {time} (jūsų laiku)",
    "cal.mkt.earlyAt": "Užsidaro anksčiau, {time}",
    "cal.local": "vietos laiku",
    "cal.country": "Šalis",
    "cal.types": "Įvykių tipai",
    "cal.group.central_bank": "Centriniai bankai",
    "cal.group.data_release": "Ekonomikos duomenys",
    "cal.group.markets": "Biržų nedarbo dienos",
    "cal.group.public_holiday": "Šventės",
    "cal.badge.central_bank": "Palūkanų sprendimas",
    "cal.badge.data_release": "Duomenų skelbimas",
    "cal.badge.market_closed": "Birža nedirba",
    "cal.badge.early_close": "Ankstesnis uždarymas",
    "cal.badge.public_holiday": "Šventė",
    "cal.closesEarly": "ankstesnis uždarymas",
    "cal.noTrading": "visą dieną nėra prekybos",
    "cal.released": "Paskelbta",
    "cal.seeFigure": "Žiūrėti oficialų skaičių",
    "cal.sourceShort": "Šaltinis",
    "cal.news": "Naujienos",
    "cal.openNote": "{exchange} dirba",
    "cal.plusMore": "dar: {n}",
    "cal.oneEvent": "1 įvykis",
    "cal.nEvents": "Įvykių: {n}",
    "cal.oneHoliday": "1 šventė",
    "cal.nHolidays": "Švenčių: {n}",
    "cal.nowLine": "Dabar · {time}",
    "cal.weekendClosed": "Savaitgalis: biržos nedirba.",
    "cal.nothingDay": "Nieko nesuplanuota.",
    "cal.thisWeek": "Ši savaitė",
    "cal.nextWeekLabel": "Kita savaitė",
    "cal.earlier": "Anksčiau šią savaitę",
    "cal.show": "Rodyti",
    "cal.tryAll": "Pasirinkite visus įvykių tipus arba išjunkite „Jūsų šalys“.",
    "cal.reset": "Atstatyti filtrus",
    "cal.prevWeek": "Ankstesnė savaitė",
    "cal.nextWeek": "Kita savaitė",
    "cal.moreWeek": "Rodyti kitą savaitę",
    "cal.subscribeTitle": "Prenumeruoti šį kalendorių",
    "cal.feedAddress": "Kalendoriaus adresas",
    "cal.copyLink": "Kopijuoti nuorodą",
    "cal.subFine": "Nemokamai, be paskyros. Atsižvelgia į jūsų pasirinktus filtrus. Naujienos ir kontekstas, ne finansinė konsultacija.",
    "cal.impact": "Poveikis",
    "cal.imp.high": "Didelis",
    "cal.imp.medium": "Vidutinis",
    "cal.imp.low": "Mažas",
    "cal.impTip.high": "paprastai judina palūkanas, valiutas ir akcijas",
    "cal.impTip.medium": "rinkos stebi, bet reaguoja rečiau",
    "cal.impTip.low": "fonas: šventės, smulkesni duomenys",
    "cal.impNote": "Pagal įvykio tipą, tai ne prognozė.",
    "cal.impAll": "Visi",
    "cal.impMediumUp": "Vidutinis +",
    "cal.impHighOnly": "Tik didelis",
    "cal.nHigh": "Didelio poveikio: {n}",
    "cal.addShort": "Pridėti",
};
